import request from './adminRequest'

export const blogApi = {
  listBlog (params) {
    return request.get('/blogs', { params: params })
  },
  getBlog (id) {
    return request.get('/blogs/' + id)
  },
  saveBlog (data) {
    return request.post('/blogs', data)
  },
  updateBlog (id, data) {
    return request.put('/blogs/' + id, data)
  },
  deleteBlog (id) {
    return request.delete('/blogs/' + id)
  },
  scoreBlog (id) {
    return request.post('/blogs/' + id + '/score')
  },
}
export default blogApi
